import { defineHeadPlugin } from 'unhead';

const InferSeoMetaPlugin = (options) => {
  options = options || {};
  const ogTitleTemplate = options.ogTitle || "%s";
  const ogDescriptionTemplate = options.ogDescription || "%s";
  return defineHeadPlugin({
    hooks: {
      entries: {
        resolve({ entries }) {
          for (const entry of entries) {
            const inputKey = entry.resolvedInput ? "resolvedInput" : "input";
            const input = entry[inputKey];
            const resolvedMeta = input.meta || [];
            const title = input.title;
            const ogTitle = resolvedMeta.find((meta) => meta.property === "og:title");
            const description = resolvedMeta.find((meta) => meta.name === "description")?.content;
            const ogDescription = resolvedMeta.find((meta) => meta.property === "og:description");
            entry[inputKey].meta = input.meta || [];
            if (title && !ogTitle) {
              entry[inputKey].meta.push({
                property: "og:title",
                content: (typeof ogTitleTemplate === "function" ? ogTitleTemplate(title) : ogTitleTemplate).replace("%s", title)
              });
            }
            if (description && !ogDescription) {
              const desc = String(description);
              entry[inputKey].meta.push({
                property: "og:description",
                content: (typeof ogDescriptionTemplate === "function" ? ogDescriptionTemplate(desc) : ogDescriptionTemplate).replace("%s", desc)
              });
            }
          }
          const metas = [];
          if (options?.robots !== false) {
            metas.push({
              name: "robots",
              content: options?.robots || "max-snippet: -1; max-image-preview: large; max-video-preview: -1"
            });
          }
          if (options?.twitterCard !== false) {
            metas.push({
              property: "twitter:card",
              content: options?.twitterCard || "summary_large_image"
            });
          }
          const rootEntry = {
            _i: -1,
            _sde: {},
            input: {
              meta: metas
            }
          };
          entries.unshift(rootEntry);
        }
      }
    }
  });
};

const DefaultCriticalTags = {
  htmlAttrs: {
    lang: "en"
  },
  meta: [
    { charset: "utf-8" },
    { name: "viewport", content: "width=device-width, initial-scale=1" }
  ]
};

export { DefaultCriticalTags, InferSeoMetaPlugin };
